import _ from 'lodash';
import * as types from './action-types';
import BankService from 'frilans-finans/bank/bank-service';

export function reset () {
  return {
    type: types.RESET
  };
}

export function setBanks (payload) {
  return {
    type: types.SET_BANKS,
    payload: payload
  };
}

export function setSelectedBank (payload) {
  return {
    type: types.SET_SELECTED_BANK,
    payload: payload
  };
}

export function setClearingNumber (payload) {
  return {
    type: types.SET_CLEARING_NUMBER,
    payload: payload
  };
}

export function setClearingNumberIsValid (payload) {
  return {
    type: types.SET_CLEARING_NUMBER_IS_VALID,
    payload: payload
  };
}

export function setClearingNumberSuppressError (payload) {
  return {
    type: types.SET_CLEARING_NUMBER_SUPPRESS_ERROR,
    payload: payload
  };
}

export function setClearingNumberErrorMessage (payload) {
  return {
    type: types.SET_CLEARING_NUMBER_ERROR_MESSAGE,
    payload: payload
  };
}

export function setAccountNumber (payload) {
  return {
    type: types.SET_ACCOUNT_NUMBER,
    payload: payload
  };
}

export function setAccountNumberIsValid (payload) {
  return {
    type: types.SET_ACCOUNT_NUMBER_IS_VALID,
    payload: payload
  };
}

export function setAccountNumberSuppressError (payload) {
  return {
    type: types.SET_ACCOUNT_NUMBER_SUPPRESS_ERROR,
    payload: payload
  };
}

export function setAccountNumberErrorMessage (payload) {
  return {
    type: types.SET_ACCOUNT_NUMBER_ERROR_MESSAGE,
    payload: payload
  };
}

export function setBank (bank) {
  return (dispatch) => {
    if (bank === 'NORDEA_PERSON') {
      dispatch(setClearingNumber('3300'));
    }

    dispatch(setSelectedBank(bank));
  };
}

export function fetchBanks () {
  return (dispatch) => {
    BankService.get().promise.then((banks) => {
      dispatch(setBanks(banks));
    });
  };
}

export function syncBankInfoFromUser () {
  return (dispatch, getState) => {
    const state = getState();
    if (state.user.internationalAccount === 'on') {
      dispatch(setSelectedBank('IBAN'));
      dispatch(setClearingNumber(state.user.bic));
      dispatch(setAccountNumber(state.user.iban));
    } else {
      const hasBank = state.user.accountClearingNr || state.user.accountNr;
      const hasChangedAccountNr = state.bankInfo.accountNumber.value &&
        state.user.accountNr !== state.bankInfo.accountNumber.value;
      const hasChangedClearingNr = state.bankInfo.clearingNumber.value &&
        state.user.accountClearingNr !== state.bankInfo.clearingNumber.value;
      const hasSelectedBank = state.bankInfo.selectedBank !== 'INITIAL';
      if (hasBank && !hasChangedAccountNr && !hasChangedClearingNr && !hasSelectedBank) {
        dispatch(setSelectedBank(identifyBank(state.user.accountClearingNr, state.bankInfo.banks)));
        dispatch(setClearingNumber(state.user.accountClearingNr));
        dispatch(setAccountNumber(state.user.accountNr));
      }
    }
  };
}

export function identifyBank (clearingNumber, banks) {
  if (_.isEmpty(clearingNumber)) {
    return 'INITIAL';
  }

  // There is some overlap in ff_banks, so that it is not possible to find
  // the Nordea personnummer account in the list.
  if (clearingNumber === '3300') {
    return 'NORDEA_PERSON';
  }

  const bank = findBankByClearingNumber(clearingNumber, banks);

  if (bank) {
    if (_.includes([1, 4, 5, 6, 9, 12, 14, 39, 46], bank.id)) {
      return 'NORDEA_KONTO';
    }

    if (_.includes([10, 13], bank.id)) {
      return 'NORDEA_PERSON';
    }

    if (_.includes([15, 24, 25], bank.id)) {
      return 'SEB';
    }

    if (_.includes([16], bank.id)) {
      return 'HANDELSBANKEN';
    }

    if (_.includes([17, 18], bank.id)) {
      return 'SWEDBANK';
    }
  }

  return 'OTHER';
}

function findBankByClearingNumber (clearingNumber, banks) {
  if (clearingNumber.length > 4) {
    clearingNumber = clearingNumber.slice(0, 4);
  }

  for (const bank of banks) {
    if (_.inRange(clearingNumber, bank.clrMin, bank.clrMax + 1)) {
      return bank;
    }
  }

  return null;
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-info/index.js
 **/